import React, { useRef } from "react";
import Keyboard from "react-simple-keyboard";
import "react-simple-keyboard/build/css/index.css";
import PasswordInput from "../reusableComponents/PasswordInput";

export function KeyboardComponent({ userData, setUserData, hideKeyboard }) {
    const [layout, setLayout] = React.useState("default");
    const keyboard = useRef();

    const onChange = input => {
        setUserData(prevData => ({
            ...prevData,
            password: input
        }));
        console.log("Input changed", input);
    };

    const handleShift = () => {
        const newLayoutName = layout === "default" ? "shift" : "default";
        setLayout(newLayoutName);
    };

    const onKeyPress = button => {
        console.log("Button pressed", button);

        /**
         * If you want to handle the shift and caps lock buttons
         */
        if (button === "{shift}" || button === "{lock}") handleShift();
    };

    const onChangeInput = event => {
        const value = event.target.value;
        setUserData(prevData => ({
            ...prevData,
            password: value
        }));
        keyboard?.current?.setInput(value);
    };

    return (
        <div className="App">
            <PasswordInput value={userData.password} onChange={onChangeInput} inputStyles={{ paddingLeft: '10px', padding: '15px 10px', marginBottom: '20px' }} />
            {hideKeyboard && (
                <Keyboard
                    keyboardRef={r => (keyboard.current = r)}
                    layoutName={layout}
                    onChange={onChange}
                    onKeyPress={onKeyPress}
                />
            )}
        </div>
    );
}
